import { useEffect, useState } from 'react'
import { useNotificationsQuery, useReadAllNotificationsMutation, useReadNotificationMutation } from '../../core/services/react-query/useNotificationsQuery'
import MainLayout from '../../components/layouts/MainLayout'
import BellIcon from '../../components/icons/BellIcon'
import { Text, useMainContext, useWindowSize } from '../../modules/Dashboard'
import NotificationsListing from './components/NotificationsListing'
import { ScaleLoader } from 'react-spinners'
import { PaginationContainer } from '../../styles/CommonStyles'
import Pagination from 'react-js-pagination'
import { BiCheckDouble } from 'react-icons/bi'

const NotificationsPage = () => {
    const { main: { theme } } = useMainContext()
    const { width } = useWindowSize()
    const [page, setPage] = useState(1)
    const { data, isLoading, refetch } = useNotificationsQuery(page)
    const { mutate: readNotif, isLoading: isReadLoading } = useReadNotificationMutation()
    const { mutate: readAllNotifs, isLoading: isReadAllLoading } = useReadAllNotificationsMutation()

    const onNotifClick = (id) => {
        readNotif(id)
    }

    useEffect(() => {
        refetch()
    }, [page])

    const loading = isReadAllLoading || isLoading

    return (
        <MainLayout>
            {
                loading ?
                    <div className='max-w-screen-xl h-[calc(100vh-12rem)] flex items-center justify-center mx-auto backdrop-blur-2xl z-[999]'>
                        <ScaleLoader color='#9F64DF' />
                    </div> :
                    <>
                        <div className='mb-6 flex items-start justify-between'>
                            <div className='flex flex-col gap-2'>
                                <div className='flex items-center gap-2'>
                                    <span className='flex items-center justify-center w-10 h-10 bg-[#9810FA33] rounded-lg'>
                                        <BellIcon />
                                    </span>
                                    <Text tid={"notifications"} className="text-xl !text-[#F3E8FF]" />
                                </div>
                                <Text tid={"notifications-page-hint"} className="!text-[#DAB2FF] hidden md:inline" />
                            </div>
                            <button onClick={readAllNotifs} className='btn gradient-border rtl:flex-row-reverse !px-4'>
                                <BiCheckDouble size={20} />
                                <Text tid="mark-all-as-read" className='text-sm' />
                            </button>
                        </div>
                        <div className='relative pb-16'>
                            <NotificationsListing notifications={data.data} onNotifClick={onNotifClick} isReadLoading={isReadLoading} />
                            {
                                (data.data.length > 0 && data.meta.total > 0) &&
                                <PaginationContainer className='bg-transparent pt-4'>
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={10}
                                        totalItemsCount={data.meta.total}
                                        pageRangeDisplayed={3}
                                        onChange={(p) => setPage(p)}
                                        itemClass={theme === 'light' ? 'd-page-item' : 'page-item'}
                                        linkClass={theme === 'light' ? 'd-page-link' : 'page-link'}
                                    />
                                </PaginationContainer>
                            }
                        </div>

                    </>
            }
        </MainLayout>
    )
}

export default NotificationsPage